const BloodPressureIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
        <g id="Group_87030" data-name="Group 87030" transform="translate(-1483 -756)">
            <g id="Rectangle_35870" data-name="Rectangle 35870" transform="translate(1483 756)" fill="#ccecff" stroke="#0097f0" strokeWidth="1">
                <rect width="34" height="34" rx="3" stroke="none" />
                <rect x="0.5" y="0.5" width="33" height="33" rx="2.5" fill="none" />
            </g>
            <g id="Group_87029" data-name="Group 87029" transform="translate(1488 761)">
                <g id="Rectangle_35871" data-name="Rectangle 35871" transform="translate(0)" fill="#1b5984" stroke="#1b5984" strokeWidth="1" opacity="0">
                    <rect width="23.648" height="23.648" stroke="none" />
                    <rect x="0.5" y="0.5" width="22.648" height="22.648" fill="none" />
                </g>
                <g id="noun-blood-211775" transform="translate(5.225 2.956)">
                    <path id="Path_205297" data-name="Path 205297" d="M155.906,11.505a6.624,6.624,0,1,1-12.382.392,4.429,4.429,0,0,1,.876-1.909c1.11-1.595,5.556-7.07,5.556-7.07s3.913,5.027,5.261,7.07a5.676,5.676,0,0,1,.688,1.517Z" transform="translate(-143.165 -2.918)" fill="none" stroke="#1b5984" strokeWidth="1" fillRule="evenodd" />
                </g>
            </g>
        </g>
    </svg>
}

export default BloodPressureIcon